import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const get_promotion_init_list = ({ kind }) => {
    console.log("api get promotion init list:) kind[", kind, "]");

    return axiosClient.get(`/promotion?kind=${kind}`, options);
}

export const get_promotion_register_info = ({ promotionSeq }) => {
    console.log("api get promotion register info:) promotionSeq[", promotionSeq, "]");

    return axiosClient.get(`/promotion/${promotionSeq}/registerInfo`, options);
}

export const regist_promotion = ({ promotionSeq, info }) => {
    console.log("api regist promotion:) promotionSeq[", promotionSeq, "], info => ", info);

    return axiosClient.post(`/promotion/${promotionSeq}/register`, {
        emailAddress: info.email,
        licenseCode: info.license,
        itemInforsList: info.list_item
    }, options);
}

export const get_promotion_request_list = ({ promotionSeq, option }) => {
    console.log("api get promotion request list:) promotionSeq[", promotionSeq, "], option => ", option);

    if (option.keyword !== "") {
        return axiosClient.get(`/promotion/${promotionSeq}/registerList?term=${option.term}&issue=${option.issue}&item=${option.item}&keyword=${option.keyword}`, options);
    } else {
        return axiosClient.get(`/promotion/${promotionSeq}/registerList?term=${option.term}&issue=${option.issue}&item=${option.item}`, options);
    }
}

export const publish_coupon_code = ({ promotionSeq, requestSeq }) => {
    console.log("api publish coupon code:) promotionSeq[", promotionSeq, "], requestSeq[", requestSeq, "]");

    return axiosClient.put(`/promotion/${promotionSeq}/couponissue/${requestSeq}`, {}, options);
}

export const regist_coupon_code = ({ kind, promotionSeq, userSeq, info }) => {
    console.log("api regist coupon code:) kind[", kind, "], promotionSeq[", promotionSeq, "], userSeq[", userSeq, "], info => ", info);

    return axiosClient.put(`/promotion?kind=${kind}`, {
        couponCode: info.couponCode,
        userSEQ: userSeq
    }, options)
}